import {
	HomeOutlined,
	TeamOutlined,
	UserSwitchOutlined,
	ThunderboltOutlined,
	FileTextOutlined,
	CodeOutlined,
	BankOutlined,
	TagsOutlined,
	CheckSquareOutlined,
	LinkOutlined,
	DatabaseOutlined,
	WhatsAppOutlined,
	SettingOutlined,
	ApartmentOutlined,
	FundOutlined,
	CalendarOutlined,
	ContactsOutlined,
	CalculatorOutlined,
	AuditOutlined,
	DashboardOutlined,
	UnorderedListOutlined,
	BellOutlined,
	SearchOutlined,
	InboxOutlined,
	AppstoreOutlined,
} from "@ant-design/icons";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import {
	PermissaoRegraEnum,
	PermissaoGrupoUsuarioEnum,
	PermissaoUsuarioEnum,
	PermissaoEmpresaEnum,
	PermissaoAlertaEnum,
	PermissaoDepartamentoEnum,
	PermissaoCategoriaPermissaoEnum,
	PermissaoBancoFonteEnum,
	PermissaoTenantEnum,
	PermissaoWorkerEnum,
	PermissaoRodarRegrasEnum,
	PermissaoVinculoRegraEmpresaEnum,
	PermissaoWhatsAppEnum,
	PermissaoFunilVendaEnum,
	PermissaoAgendaEnum,
	PermissaoAgendamentoSistemaEnum,
	PermissaoFornecedorPendenciaEnum,
	PermissaoPortalFiscalEnum,
	PermissaoPortalContabilEnum,
	PermissaoPortalSocietarioEnum,
	PermissaoPortalGestaoEnum,
	PermissaoPortalRotinasEnum,
	PermissaoPortalAvisosEnum,
	PermissaoPortalFolhaEnum,
	PermissaoConfiguracaoGeralEnum,
} from "enum/permissao-enum";

const dashBoardNavTree = [
	{
		key: "indicadores",
		title: "indicadores",
		icon: HomeOutlined,
		breadcrumb: false,
		submenu: [
			{
				key: "lista-regras-alertas",
				path: `${APP_PREFIX_PATH}/lista-regras-alertas`,
				title: "por-empresa",
				icon: HomeOutlined,
				breadcrumb: false,
				indexNotificacoes: "empresasComErros",
				submenu: [],
				permissao: PermissaoAlertaEnum.VISUALIZAR,
			},
			{
				key: "lista-validacoes-empresas",
				path: `${APP_PREFIX_PATH}/lista-validacoes-empresas`,
				title: "por-regra",
				icon: HomeOutlined,
				breadcrumb: false,
				submenu: [],
				permissao: PermissaoAlertaEnum.VISUALIZAR,
			},
			{
				key: "lista-pendencias-fornecedor",
				path: `${APP_PREFIX_PATH}/lista-pendencias-fornecedor`,
				title: "pendencias-fornecedor",
				icon: HomeOutlined,
				breadcrumb: false,
				submenu: [],
				permissao: PermissaoFornecedorPendenciaEnum.VISUALIZAR,
			},
		],
		permissao: [
			PermissaoAlertaEnum.VISUALIZAR,
			PermissaoFornecedorPendenciaEnum.VISUALIZAR,
		],
	},
	{
		key: "gestao-clientes",
		title: "gestao-clientes",
		icon: ContactsOutlined,
		breadcrumb: false,
		submenu: [
			{
				key: "portal-gestao-visao-carteira",
				path: `${APP_PREFIX_PATH}/portal/gestao/visao-carteira`,
				title: "portal-gestao-visao-carteira",
				icon: DashboardOutlined,
				breadcrumb: false,
				submenu: [],
				permissao: PermissaoPortalGestaoEnum.VISUALIZAR_VISAO_CARTEIRA,
			},
			{
				key: "portal-gestao-financeiro",
				path: `${APP_PREFIX_PATH}/portal/gestao/financeiro`,
				title: "portal-gestao-financeiro",
				icon: DashboardOutlined,
				breadcrumb: false,
				submenu: [],
				permissao: PermissaoPortalGestaoEnum.VISUALIZAR_FINANCEIRO,
			},
			{
				key: "gestao-clientes-funil-vendas",
				path: `${APP_PREFIX_PATH}/funil-vendas`,
				title: "funil-vendas",
				icon: FundOutlined,
				breadcrumb: false,
				submenu: [],
				permissao: PermissaoFunilVendaEnum.VISUALIZAR,
			},
			{
				key: "gestao-clientes-whatsapp",
				path: `${APP_PREFIX_PATH}/whatsapp`,
				title: "whatsapp",
				icon: WhatsAppOutlined,
				breadcrumb: false,
				submenu: [],
				permissao: PermissaoWhatsAppEnum.VISUALIZAR,
			},
			{
				key: "gestao-clientes-agendamentos",
				path: `${APP_PREFIX_PATH}/agendamentos`,
				title: "agendamentos",
				icon: CalendarOutlined,
				breadcrumb: false,
				submenu: [],
				permissao: PermissaoAgendamentoSistemaEnum.VISUALIZAR,
			},
			{
				key: "gestao-clientes-agenda",
				path: `${APP_PREFIX_PATH}/agenda`,
				title: "agenda",
				icon: CalendarOutlined,
				breadcrumb: false,
				submenu: [],
				permissao: PermissaoAgendaEnum.VISUALIZAR,
			},
		],
		permissao: null,
	},
	{
		key: "portal-avisos",
		title: "portal-avisos",
		icon: BellOutlined,
		breadcrumb: false,
		submenu: [
			{
				key: "portal-avisos-omie",
				path: `${APP_PREFIX_PATH}/portal/avisos/omie`,
				title: "portal-avisos-omie",
				icon: BellOutlined,
				breadcrumb: false,
				submenu: [],
				permissao: PermissaoPortalAvisosEnum.VISUALIZAR_OMIE,
			},
			{
				key: "portal-avisos-zen",
				path: `${APP_PREFIX_PATH}/portal/avisos/zen`,
				title: "portal-avisos-zen",
				icon: BellOutlined,
				breadcrumb: false,
				submenu: [],
				permissao: PermissaoPortalAvisosEnum.VISUALIZAR_ZEN,
			},
		],
		permissao: Object.values(PermissaoPortalAvisosEnum),
	},
	{
		key: "cadastros",
		title: "cadastros",
		icon: BankOutlined,
		breadcrumb: false,
		submenu: [
			{
				key: "lista-empresas",
				path: `${APP_PREFIX_PATH}/lista-empresas`,
				title: "lista-empresas",
				icon: BankOutlined,
				breadcrumb: false,
				submenu: [],
				permissao: PermissaoEmpresaEnum.VISUALIZAR,
			},
		],
		permissao: null,
	},
	{
		key: "validacoes",
		title: "validacoes",
		icon: CheckSquareOutlined,
		breadcrumb: false,
		submenu: [
			{
				key: "lista-logs-execucao-regra",
				path: `${APP_PREFIX_PATH}/lista-logs-execucao-regra`,
				title: "logs-regras",
				icon: CodeOutlined,
				breadcrumb: false,
				submenu: [],
				permissao: PermissaoRegraEnum.VISUALIZAR_LOGS_REGRAS,
			},
			{
				key: "rodar-regras",
				path: `${APP_PREFIX_PATH}/rodar-regras`,
				title: "rodar-regras",
				icon: ThunderboltOutlined,
				breadcrumb: false,
				submenu: [],
				permissao: PermissaoRodarRegrasEnum.VISUALIZAR,
			},
			{
				key: "lista-regras",
				path: `${APP_PREFIX_PATH}/lista-regras`,
				title: "lista-regras",
				icon: CheckSquareOutlined,
				breadcrumb: false,
				submenu: [],
				permissao: PermissaoRegraEnum.EDITAR_REGRA_COMO_ADMINISTRADOR,
			},
			{
				key: "vinculo-regra-empresa",
				path: `${APP_PREFIX_PATH}/vinculo-regra-empresa`,
				title: "vinculo-regra-empresa",
				icon: LinkOutlined,
				breadcrumb: false,
				submenu: [],
				permissao: PermissaoVinculoRegraEmpresaEnum.VISUALIZAR,
			},
			{
				key: "lista-regras-usuario",
				path: `${APP_PREFIX_PATH}/lista-regras-usuario`,
				title: "lista-regras-usuario",
				icon: ThunderboltOutlined,
				breadcrumb: false,
				submenu: [],
				permissao: PermissaoRegraEnum.VISUALIZAR,
			},
		],
		permissao: null,
	},
	{
		key: "portal-fiscal",
		title: "portal-fiscal",
		icon: FileTextOutlined,
		breadcrumb: false,
		submenu: [
			{
				key: "diagnostico-fiscal",
				path: `${APP_PREFIX_PATH}/diagnostico-fiscal`,
				title: "diagnostico-fiscal",
				icon: SearchOutlined,
				breadcrumb: false,
				submenu: [],
				permissao: PermissaoPortalFiscalEnum.VISUALIZAR_DIAGNOSTICO,
			},
			{
				key: "gestao-cfop",
				path: `${APP_PREFIX_PATH}/gestao-cfop`,
				title: "gestao-cfop",
				icon: FileTextOutlined,
				breadcrumb: false,
				submenu: [],
				permissao: PermissaoPortalFiscalEnum.VISUALIZAR_CFOP,
			},
			{
				key: "portal-fiscal-log-cfop",
				path: `${APP_PREFIX_PATH}/portal/fiscal/log-cfop`,
				title: "portal-fiscal-log-cfop",
				icon: CodeOutlined,
				breadcrumb: false,
				submenu: [],
				permissao: PermissaoPortalFiscalEnum.VISUALIZAR_LOG_CFOP,
			},
			{
				key: "portal-fiscal-log-auto-cfop",
				path: `${APP_PREFIX_PATH}/portal/fiscal/log-auto-cfop`,
				title: "portal-fiscal-log-auto-cfop",
				icon: CodeOutlined,
				breadcrumb: false,
				submenu: [],
				permissao: PermissaoPortalFiscalEnum.VISUALIZAR_LOG_AUTO_CFOP,
			},
			{
				key: "cruzamento-notas",
				path: `${APP_PREFIX_PATH}/cruzamento-notas`,
				title: "cruzamento-notas",
				icon: FileTextOutlined,
				breadcrumb: false,
				submenu: [],
				permissao: PermissaoPortalFiscalEnum.VISUALIZAR_CRUZAMENTO,
			},
			{
				key: "cruzamento-notas-saida",
				path: `${APP_PREFIX_PATH}/cruzamento-notas-saida`,
				title: "cruzamento-notas-saida",
				icon: FileTextOutlined,
				breadcrumb: false,
				submenu: [],
				permissao: PermissaoPortalFiscalEnum.VISUALIZAR_CRUZAMENTO_SAIDA,
			},
			{
				key: "portal-fiscal-log-cruzamento",
				path: `${APP_PREFIX_PATH}/portal/fiscal/log-cruzamento`,
				title: "portal-fiscal-log-cruzamento",
				icon: CodeOutlined,
				breadcrumb: false,
				submenu: [],
				permissao: PermissaoPortalFiscalEnum.VISUALIZAR_LOG_CRUZAMENTO,
			},
		],
		permissao: Object.values(PermissaoPortalFiscalEnum),
	},
	{
		key: "portal-contabil",
		title: "portal-contabil",
		icon: CalculatorOutlined,
		breadcrumb: false,
		submenu: [
			{
				key: "portal-contabil-bloqueios",
				path: `${APP_PREFIX_PATH}/portal/contabil/bloqueios`,
				title: "portal-contabil-bloqueios",
				icon: CalculatorOutlined,
				breadcrumb: false,
				submenu: [],
				permissao: PermissaoPortalContabilEnum.VISUALIZAR_BLOQUEIOS,
			},
			{
				key: "portal-contabil-log-bloqueios",
				path: `${APP_PREFIX_PATH}/portal/contabil/log-bloqueios`,
				title: "portal-contabil-log-bloqueios",
				icon: CodeOutlined,
				breadcrumb: false,
				submenu: [],
				permissao: PermissaoPortalContabilEnum.VISUALIZAR_LOG_BLOQUEIOS,
			},
		],
		permissao: Object.values(PermissaoPortalContabilEnum),
	},
	{
		key: "portal-societario",
		title: "portal-societario",
		icon: AuditOutlined,
		breadcrumb: false,
		submenu: [
			{
				key: "portal-societario-contratos",
				path: `${APP_PREFIX_PATH}/portal/societario/contratos`,
				title: "portal-societario-contratos",
				icon: AuditOutlined,
				breadcrumb: false,
				submenu: [],
				permissao: PermissaoPortalSocietarioEnum.VISUALIZAR_CONTRATOS,
			},
			{
				key: "portal-societario-atualizador",
				path: `${APP_PREFIX_PATH}/portal/societario/atualizador`,
				title: "portal-societario-atualizador",
				icon: AuditOutlined,
				breadcrumb: false,
				submenu: [],
				permissao: PermissaoPortalSocietarioEnum.VISUALIZAR_ATUALIZADOR,
			},
			{
				key: "portal-societario-certificados",
				path: `${APP_PREFIX_PATH}/portal/societario/certificados`,
				title: "portal-societario-certificados",
				icon: AuditOutlined,
				breadcrumb: false,
				submenu: [],
				permissao: PermissaoPortalSocietarioEnum.VISUALIZAR_CERTIFICADOS,
			},
		],
		permissao: Object.values(PermissaoPortalSocietarioEnum),
	},
	{
		key: "portal-folha",
		title: "portal-folha",
		icon: TeamOutlined,
		breadcrumb: false,
		submenu: [
			{
				key: "portal-folha-home",
				path: `${APP_PREFIX_PATH}/portal/folha`,
				title: "portal-folha",
				icon: TeamOutlined,
				breadcrumb: false,
				submenu: [],
				permissao: PermissaoPortalFolhaEnum.VISUALIZAR,
			},
		],
		permissao: [PermissaoPortalFolhaEnum.VISUALIZAR],
	},
	{
		key: "portal-rotinas",
		title: "portal-rotinas",
		icon: UnorderedListOutlined,
		breadcrumb: false,
		submenu: [
			{
				key: "portal-rotinas-painel",
				path: `${APP_PREFIX_PATH}/portal/rotinas`,
				title: "portal-rotinas-painel",
				icon: UnorderedListOutlined,
				breadcrumb: false,
				submenu: [],
				permissao: PermissaoPortalRotinasEnum.VISUALIZAR_PAINEL,
			},
			{
				key: "portal-rotinas-tipos",
				path: `${APP_PREFIX_PATH}/portal/rotinas/tipos`,
				title: "portal-rotinas-tipos",
				icon: UnorderedListOutlined,
				breadcrumb: false,
				submenu: [],
				permissao: PermissaoPortalRotinasEnum.VISUALIZAR_TIPOS,
			},
			{
				key: "portal-rotinas-matriz",
				path: `${APP_PREFIX_PATH}/portal/rotinas/matriz`,
				title: "portal-rotinas-matriz",
				icon: AppstoreOutlined,
				breadcrumb: false,
				submenu: [],
				permissao: PermissaoPortalRotinasEnum.VISUALIZAR_TIPOS,
			},
			{
				key: "portal-rotinas-domicilios",
				path: `${APP_PREFIX_PATH}/portal/rotinas/domicilios`,
				title: "portal-rotinas-domicilios",
				icon: InboxOutlined,
				breadcrumb: false,
				submenu: [],
				permissao: PermissaoPortalRotinasEnum.VISUALIZAR_DOMICILIOS,
			},
		],
		permissao: Object.values(PermissaoPortalRotinasEnum),
	},
	{
		key: "configuracoes",
		title: "configuracoes",
		icon: TeamOutlined,
		breadcrumb: false,
		submenu: [
			{
				key: "lista-usuarios",
				path: `${APP_PREFIX_PATH}/lista-usuarios`,
				title: "lista-usuarios",
				icon: TeamOutlined,
				breadcrumb: false,
				submenu: [],
				permissao: PermissaoUsuarioEnum.VISUALIZAR,
			},
			{
				key: "lista-grupos-usuario",
				path: `${APP_PREFIX_PATH}/lista-grupos-usuario`,
				title: "lista-grupos-usuario",
				icon: UserSwitchOutlined,
				breadcrumb: false,
				submenu: [],
				permissao: PermissaoGrupoUsuarioEnum.VISUALIZAR,
			},
			{
				key: "lista-departamentos",
				path: `${APP_PREFIX_PATH}/lista-departamentos`,
				title: "lista-departamentos",
				icon: BankOutlined,
				breadcrumb: false,
				submenu: [],
				permissao: PermissaoDepartamentoEnum.VISUALIZAR,
			},
			{
				key: "lista-categorias",
				path: `${APP_PREFIX_PATH}/lista-categorias`,
				title: "lista-categorias",
				icon: TagsOutlined,
				breadcrumb: false,
				submenu: [],
				permissao: PermissaoCategoriaPermissaoEnum.VISUALIZAR,
			},
		],
		permissao: null,
	},
	{
		key: "configuracoes-gerais",
		path: `${APP_PREFIX_PATH}/configuracoes-gerais`,
		title: "configuracoes-gerais",
		icon: SettingOutlined,
		breadcrumb: false,
		submenu: [
			{
				key: "configuracoes-gerais-lista-bases",
				path: `${APP_PREFIX_PATH}/lista-bases`,
				title: "lista-bases",
				icon: DatabaseOutlined,
				breadcrumb: false,
				submenu: [],
				permissao: PermissaoBancoFonteEnum.VISUALIZAR,
			},
			{
				key: "configuracoes-gerais-lista-workers",
				path: `${APP_PREFIX_PATH}/lista-workers`,
				title: "lista-workers",
				icon: ThunderboltOutlined,
				breadcrumb: false,
				submenu: [],
				permissao: PermissaoWorkerEnum.VISUALIZAR,
			},
			{
				key: "lista-tenants",
				path: `${APP_PREFIX_PATH}/lista-tenants`,
				title: "lista-tenants",
				icon: ApartmentOutlined,
				breadcrumb: false,
				submenu: [],
				permissao: PermissaoTenantEnum.VISUALIZAR,
			},
			{
				key: "configuracao-notas",
				path: `${APP_PREFIX_PATH}/configuracao-notas`,
				title: "configuracao-notas",
				icon: FileTextOutlined,
				breadcrumb: false,
				submenu: [],
				permissao: PermissaoConfiguracaoGeralEnum.CONFIGURAR,
			},
			{
				key: "configuracoes-gerais-whatsapp-conf",
				path: `${APP_PREFIX_PATH}/whatsapp-config`,
				title: "whatsapp-conf",
				icon: WhatsAppOutlined,
				breadcrumb: false,
				submenu: [],
				permissao: PermissaoWhatsAppEnum.VISUALIZAR,
			},
		],
		permissao: null,
	},
];

const navigationConfig = [...dashBoardNavTree];

export default navigationConfig;
